import styled, { css } from 'styled-components';
import sizes from 'themes/sizes';

const getValue = (map, key) => map[key] || map.default;

const sizesMap = {
  supersmall: '12px',
  small: '14px',
  default: '16px',
  medium: '20px',
  large: '24px',
};

const colorsMap = {
  default: '#262635',
  accent: '#262635',
  danger: '#FF3B3B',
  sell: '#FF3B3B',
  buy: '#19AE53',
};

export default styled.div`
  ${sizes};
  font-size: ${(props) => getValue(sizesMap, props.size)};
  color: ${(props) => props.color || getValue(colorsMap, props.type)};
  text-transform: ${(props) => props.transform || 'none'};
  text-align: ${(props) => props.align || 'left'};
  display: ${(props) => props.display || 'block'};
  position: ${(props) => props.position || 'static'};
  ${(props) =>
    props.underline
      ? css`
          text-decoration: underline;
        `
      : ''}
`;
